"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBody = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../helpers");
const Cell_1 = require("./Cell");
const Row_1 = require("./Row");
const TableBody = ({ getTableBodyProps, tableData, prepareRow, tableRowConfig, rowOnMouseLeave, editedRows, setRows, }) => (react_1.default.createElement("div", { className: 'table-body', ...getTableBodyProps() }, tableData.map((row) => {
    prepareRow(row);
    const { key, ...rowProps } = row.getRowProps();
    return (react_1.default.createElement(Row_1.Row, { key: key, rowOnMouseLeave: rowOnMouseLeave, className: 'row', ...rowProps }, row.cells.map((cell, cellIndex) => {
        const cellId = cell.column.id;
        const rowId = cell.row.id;
        const desiredRowIndex = editedRows.findIndex((row) => row.id === rowId);
        const handleChange = (value) => {
            const tempRows = [...editedRows];
            if (desiredRowIndex >= 0) {
                const desiredRow = tempRows[desiredRowIndex];
                desiredRow[String(cellId)] = value;
                setRows(tempRows);
            }
            else {
                const newEditedRow = {
                    id: rowId,
                    // Keep legacy behavior: pass row.original.id to save handlers.
                    // Some callsites rely on this carrying original row payload.
                    // @ts-expect-error `id` is not guaranteed by generic `T`.
                    rowId: cell.row.original.id,
                };
                newEditedRow[String(cellId)] = value;
                setRows([...editedRows, newEditedRow]);
            }
        };
        const { isNextSticky, isLast, stickyOffset } = (0, helpers_1.calcStickyProperties)(cellIndex, 
        // ICell<T> & { column: TableRowCellsConfig<T> }
        // @ts-expect-error
        row.cells.map((cell) => cell.column));
        return (
        // @ts-expect-error
        react_1.default.createElement(Cell_1.Cell, { key: 'tab_' + row.id + '_' + cell.column.id, cell: cell, originalRow: row.original, editRows: handleChange, editValue: editedRows[desiredRowIndex], allEditedRows: editedRows, isSticky: cell.column
                .sticky ||
                (isNextSticky && cell.column.id === 'selection'), isLast: isLast, stickyOffset: stickyOffset, isNextSticky: isNextSticky, tableRowConfig: tableRowConfig }));
    })));
})));
exports.TableBody = TableBody;
